import React from 'react';
import { useEffect, useState } from 'react';
import './switch.css';

export const Switch = ({data = [], initialValue, onChange = (v) => {}, className = ''}) => {

    const [index, setIndex] = useState(data.findIndex(e => e.value === initialValue));

    useEffect(() => {
        onChange(data[index]?.value)
    }, [index]);

    const move = (forward = true) => {
        setIndex(
            forward ?
                (index === 0) ? data.length - 1
                : index - 1
            : (index >= data.length - 1) ? 0
            : index + 1
        );
    }

    const keyUp = (e) => {
        if (e.code === 'Space' || e.code === 'ArrowRight' || e.code === 'ArrowLeft') {
            e.preventDefault();

            move((e.code === 'Space' && e.shiftKey) || e.code === 'ArrowLeft');
        }
    }

    return <div className={'input-mimic input-switch' + (className ? ' ' + className : '')} tabIndex={0} onKeyUp={e => keyUp(e)}>
        <div className='input-highlight' style={{
            width: `${100 / data.length}%`,
            transform: `translateX(${index * 100}%)`,
            '--active-color': data[index]?.color,
        }}></div>
        {
            data.map((d, i) => <div
                key={d.key ?? i}
                className={'input-option' + (i === index ? ' highlighted' : '')}
                onClick={() => setIndex(i)}
            >
                {d.label ?? ''}
            </div>)
        }
    </div>
}